import React from 'react';
import {useTranslation} from "react-i18next";

import NameSection from "../workgroupForm/NameSection";
import useWorkgroupForm from "../workgroupForm/useWorkgroupForm";
import MDLoadingButton from "../../../components/MDLoadingButton";
import {useUpdateWorkgroup} from "../query";

import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import MDInput from "materialDashboard/components/MDInput";
import MDBox from "materialDashboard/components/MDBox";
import MDButton from "materialDashboard/components/MDButton";


const PanelInfo = ({workgroup}) => {
    const {t} = useTranslation(['workgroups']);

    const workgroupMutation = useUpdateWorkgroup(workgroup.id);

    const handleSubmit = async (data) => {
        await workgroupMutation.mutateAsync(data);
    }

    const {formik} = useWorkgroupForm({workgroup, onSubmit: handleSubmit});
    const submitDisabled = !formik.dirty || (formik.submitCount > 0 && !formik.isValid);

    return <Card sx={{p: 3}}>
        <Stack spacing={3}>
            <NameSection formik={formik} workgroup={workgroup}/>

            <Stack direction="row">
                <MDBox width="5rem" sx={{overflow: "hidden", textAlign: "center"}}>
                    {workgroup.logo?.path && <img src={workgroup.logo?.path} alt="workgroup_logo" style={{width: "100%"}}/>}
                </MDBox>
                <MDInput type="file"
                         name="logo"
                         label={t('workgroupForm.logo')}
                         variant="standard"
                         fullWidth
                         onChange={ (e) => {
                             formik.setFieldValue("logo", e.currentTarget.files[0]);
                         }}
                         error={formik.touched.logo && Boolean(formik.errors.logo)}
                         helperText={formik.touched.logo && formik.errors.logo}
                         InputLabelProps={{ shrink: true }}
                />
            </Stack>

            <Stack direction="row">
                <MDBox width="5rem" sx={{overflow: "hidden", textAlign: "center"}}>
                    {workgroup.icon?.path && <img src={workgroup.icon?.path} alt="workgroup_icon" style={{width: "20px"}}/>}
                </MDBox>
                <MDInput type="file"
                         name="icon"
                         label={t('workgroupForm.icon')}
                         variant="standard"
                         fullWidth
                         onChange={ (e) => {
                             formik.setFieldValue("icon", e.currentTarget.files[0]);
                         }}
                         error={formik.touched.icon && Boolean(formik.errors.icon)}
                         helperText={formik.touched.icon && formik.errors.icon}
                         InputLabelProps={{ shrink: true }}
                />
            </Stack>

            <Stack direction="row" spacing={2} justifyContent="flex-end">
                <MDButton color="info" variant="text"
                          onClick={() => formik.resetForm()}
                          disabled={!formik.dirty}>
                    {t('workgroup.panelInfo.cancel')}
                </MDButton>
                <MDLoadingButton variant="gradient" color="info" onClick={formik.handleSubmit}
                                 disabled={submitDisabled}
                                 loading={formik.isSubmitting}>
                    {t('workgroup.panelInfo.submit')}
                </MDLoadingButton>
            </Stack>
        </Stack>
    </Card>
}


export default PanelInfo;